
export class EnderecoCapacitadora
{
    public id : number;
    public id_endereco: number;
    public id_capacitadora: number;
    public data_exclusao: Date;

}


// WEBPACK FOOTER //
// ./src/app/entity/endereco-capacitadora.model.ts